import "./document-generation-error-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const DocumentGenerationErrorModal = ({
	isOpen,
	onClose,
}: {
	isOpen: boolean;
	onClose: () => void;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"document-generation-error-modal"}
			confirmText={"Ok"}
			confirmVariant={"danger"}
			onClose={onClose}
			onConfirm={onClose}
			showCancelButton={false}
			showConfirmationButtons={true}
			title={"Document Generation Error"}
			type={"error"}
			width={401}
		>
			<div className={"document-generation-error-content"}>
				<SvgIcon
					className={"document-generation-error-icon"}
					icon={alertTriangle}
				/>
				<p>
					New documents could not be generated at this time. Please try again.
				</p>
			</div>
		</TraxModal>
	);
};
